import React, { PropsWithChildren, useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { SubscriptionProviderCore } from 'src/providers/optimisedDataSubscriptions/optimisedSubscriptionsCore';
import { needsDataRequirement } from 'src/utils/routeDataRequirements';

const INITIAL_CONTEXT_VALUE: {
	subscriptionProvider: SubscriptionProviderCore;
} = {
	subscriptionProvider: new SubscriptionProviderCore(),
};

export const OptimisedSubscriptionsContext = React.createContext(
	INITIAL_CONTEXT_VALUE
);

const OptimisedSubscriptionsProvider = (props: PropsWithChildren<any>) => {
	const pathname = usePathname();

	// Check if current route needs token balance subscriptions
	// Enable on trading (for wallet balances), earn (for staking), portfolio (for collateral), and dev pages
	const needsSubscriptions = pathname
		? needsDataRequirement(pathname, 'trading') ||
			needsDataRequirement(pathname, 'earn') ||
			needsDataRequirement(pathname, 'portfolio') ||
			pathname.startsWith('/dev')
		: false;

	const contextValue = useMemo(() => {
		if (!needsSubscriptions) {
			// Return a minimal context when subscriptions aren't needed
			return {
				subscriptionProvider: new SubscriptionProviderCore(),
			};
		}

		return INITIAL_CONTEXT_VALUE;
	}, [needsSubscriptions]);

	return (
		<OptimisedSubscriptionsContext value={contextValue}>
			{props.children}
		</OptimisedSubscriptionsContext>
	);
};

export default OptimisedSubscriptionsProvider;
